
import newApi from '../../api/news'
import NewsBlock from './NewsBlock'
export default {
  name: 'NewsLine',
  components: { NewsBlock },
  props: {
    countNewsToDisplay: {
      required: false,
      type: Number,
      default: 4
    }
  },
  data () {
    return {
      news: []
    }
  },
  async fetch () {
    this.news = await newApi.getLastNews({ topic: '380' })
      .then(res =>
        res.data.slice(0, this.countNewsToDisplay)
      )
      .catch(reason =>
        []
      )
  },
  fetchOnServer: false
}
